import { render, staticRenderFns } from "./MemberFilesTable.vue?vue&type=template&id=504ddc2e"
import script from "./MemberFilesTable.vue?vue&type=script&lang=js"
export * from "./MemberFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports